if (!customElements.get("predictive-search-heading")) {
  class PredictiveSearchHeading extends HTMLElement {
    constructor() {
      super();
    }

    setInnerHTML(data) {
      const parser = new DOMParser().parseFromString(data, "text/html");
      const textElement = parser.querySelector(".js-predictive-search-heading");
      if (!textElement) return;
      this.innerHTML = textElement.innerHTML;
    }

    connectedCallback() {
      fetch(
        routes.search_url +
          "?q=" +
          this.getAttribute("data-search-term") +
          "&view=count&type=product"
      )
        .then((response) => response.text())
        .then((data) => {
          this.setInnerHTML(data);
        })
        .catch((error) => console.error(error));
    }
  }

  customElements.define("predictive-search-heading", PredictiveSearchHeading);
}
